import { nextTick, ref } from 'vue'
import { ElMessage } from 'element-plus'
import Cookies from 'js-cookie'

import i18n from './index'
import type { AppLocales } from './types/AppLocales'

export function useLocaleSwitch() {
  const isLoading = ref(false)

  const switchLocale = async (locale: AppLocales): Promise<void> => {
    if (i18n.global.locale.value === locale) {
      return
    }

    isLoading.value = true
    await nextTick()

    try {
      i18n.global.locale.value = locale
      Cookies.set('language', locale, { expires: 365 })
      await nextTick()
    } finally {
      isLoading.value = false

      ElMessage({
        message: i18n.global.t('localeChanged'),
        type: 'success'
      })
    }
  }

  return { switchLocale, isLoading, currentLocale: i18n.global.locale }
}
